import React, { useState, useEffect, useReducer } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function ItemMaskingChange(props) {
    const [sqLDbList, setSqLDbList] = useState([])
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSources, setDataSources] = useState([])
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [dimensions, setDimensions] = useState([])
    const [loadedMembers, setLoadedMembers] = useState([])

    // UI State Variables
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [selectedDimension, setSelectedDimension] = useState('')
    const [changedItemMaskingList, setChangedItemMaskingList] = useState([])
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    //#region useEffect
    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            callForPropDataToLoadExisting()
        } else {
            resetStateData()
        }
    }, [])
    useEffect(() => {
        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            callForPropDataToLoadExisting()
        } else {
            resetStateData()
        }
    }, [props.taskData.databaseId])
    //#endregion

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dsSystemName - Data source system name from the selected database
     */
    function fireOnSaveEvent(dbId, dsSystemName, changedItemMaskingList) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["dataSourceSystemName"] = dsSystemName
            copied["memberMaskings"] = changedItemMaskingList
            props.onSave(copied)
        }
    }

    //#region State Set Methods
    function resetStateData() {
        setDatabaseId(-1)
        setDataSources([])
        setDataSourceSystemName('')
        setDimensions([])
        setIsLoadingRequest(false)
        setSelectedDimension('')
        setLoadedMembers([])
    }
    function callForPropDataToLoadExisting() {
        setDatabaseId(props.taskData.databaseId)
        setIsLoadingRequest(true)

        if (props.taskData.memberMaskings && props.taskData.memberMaskings.length > 0) {
            setChangedItemMaskingList(props.taskData.memberMaskings)
        }

        let getDataSources = props.getDataSources(props.taskData.databaseId)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setDataSources(json)
            setDataSourceSystemName(props.taskData.dataSourceSystemName)
            setDimensions([])
            setLoadedMembers([])

            let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
            getDimensions.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                let dimensionsFromDataSource = json.filter(x => x.typeOfDimension !== -1)
                
                setIsLoadingRequest(false)
                setDimensions(dimensionsFromDataSource)
                fireOnSaveEvent(props.taskData.databaseId, props.taskData.dataSourceSystemName, [])
            }).catch((ex) => {
                console.error(ex)
                resetStateData()
            })
        }).catch((ex) => {
            console.error(ex)
            resetStateData()
        })
    }
    function loadMoreDimensionMembers(dbId, dsSystemName, selectedDimensionSystemName, alreadyLoaded) {
        setIsLoadingRequest(true)
        let copiedAlreadyLoaded = getSystemIdsOfDimensionAlreadyLoadedMembers(loadedMembers, selectedDimensionSystemName)
        let getDimensionMembersCall = props.getDimensionMembers(dbId, dsSystemName, selectedDimensionSystemName, copiedAlreadyLoaded, '')
        getDimensionMembersCall.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            
            // Add already loaded to the state
            let newCopiedAlreadyLoaded = alreadyLoaded
            for (let x = 0; x < json.length; x++) {
                json[x]["dimensionSystemName"] = selectedDimensionSystemName
                newCopiedAlreadyLoaded.push(json[x])
            }
            setLoadedMembers(newCopiedAlreadyLoaded)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
        })
    }
    //#endregion

    //#region Handlers Events
    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setIsLoadingRequest(true)
        setDataSources([])
        setDataSourceSystemName('')
        setSelectedDimension('')
        setLoadedMembers([])

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setDataSources(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(event.target.value, '', [])
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setDataSourceSystemName('')
            setLoadedMembers([])
            setIsLoadingRequest(false)
        })
    }
    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)
        setDimensions([])
        setLoadedMembers([])
        setIsLoadingRequest(true)

        let getDimensions = props.getDimensions(databaseId, event.target.value)
        getDimensions.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dimensionsFromDataSource = json.filter(x => x.typeOfDimension !== -1)

            setIsLoadingRequest(false)
            setDimensions(dimensionsFromDataSource)
            fireOnSaveEvent(databaseId, event.target.value, [])
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setLoadedMembers([])
            setSelectedDimension('')
            setDataSourceSystemName('')
            setIsLoadingRequest(false)
        })
    }
    function handleDimensionChange(event) {
        event.preventDefault()
        setSelectedDimension(event.target.value)
        setIsLoadingRequest(true)

        let alreadyLoaded = getSystemIdsOfDimensionAlreadyLoadedMembers(loadedMembers, event.target.value)
        let getDimensionMembersCall = props.getDimensionMembers(databaseId, dataSourceSystemName, event.target.value, alreadyLoaded, '')
        getDimensionMembersCall.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            
            // Add already loaded to the state
            let copiedAlreadyLoaded = loadedMembers
            let copiedMaskList = changedItemMaskingList
            for (let x = 0; x < json.length; x++) {
                json[x]["dimensionSystemName"] = event.target.value
                let newObject = { "memberSystemName": json[x]["systemName"], "dimensionSystemName": event.target.value, "maskingValue": json[x]["alias"] }
                
                copiedAlreadyLoaded.push(json[x])
                copiedMaskList.push(newObject)
            }
            setLoadedMembers(copiedAlreadyLoaded)
            setChangedItemMaskingList(copiedMaskList)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
        })
    }
    //#endregion

    //#region Render Methods
    function renderSegmentationAssignmentTable(selectedDimensionSystemName, dimensionData, membersWeAlreadyLoaded, changedItemMaskingList, dbId, dsSystemName) {
        let dimensionLookup = dimensionData.filter(x => x.systemName === selectedDimensionSystemName)
        let memberRows = []

        if (dimensionLookup.length > 0) {
            let membersForDimension = membersWeAlreadyLoaded.filter(x => x.dimensionSystemName === selectedDimensionSystemName)

            for (let memberItr = 0; memberItr < membersForDimension.length; memberItr++) {
                memberRows.push(<TableRow key={`member-${selectedDimensionSystemName}-$${membersForDimension[memberItr]["systemName"]}`}>
                    <TableCell>{membersForDimension[memberItr]["memberName"]}</TableCell>
                    <TableCell>
                        <TextField
                            fullWidth
                            label="File Description"
                            variant="outlined"
                            defaultValue={membersForDimension[memberItr]["alias"]}
                            value={getCurrentItemMask(selectedDimensionSystemName, membersForDimension[memberItr]["systemName"], membersWeAlreadyLoaded, changedItemMaskingList)}
                            disabled={false}
                            onChange={(e) => {
                                e.preventDefault()

                                let newObject = { "memberSystemName": membersForDimension[memberItr]["systemName"], "dimensionSystemName": membersForDimension[memberItr]["dimensionSystemName"], "maskingValue": e.target.value }
                                let copied = changedItemMaskingList
                                let index = getIndexForMatchingItemOnList(copied, membersForDimension[memberItr]["systemName"], membersForDimension[memberItr]["dimensionSystemName"])
                                if (index === -1) {
                                    copied.push(newObject)
                                } else {
                                    copied[index] = newObject
                                }
                                setChangedItemMaskingList(copied)
                                fireOnSaveEvent(dbId, dsSystemName, copied)
                                forceUpdate()
                            }} />
                    </TableCell>
                </TableRow>)
            }
        }

        if (memberRows.length === 0) {
            return null
        }
        
        return <TableContainer component={Paper}>
            <Table size="small" aria-label="Segmentation Assignment Table">
                <TableHead>
                    <TableRow>
                        <TableCell>Member Name</TableCell>
                        <TableCell>Member Alias</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {memberRows}
                </TableBody>
            </Table>
        </TableContainer>
    }
    //#endregion

    //#region Data Handler Methods
    function getSystemIdsOfDimensionAlreadyLoadedMembers(copiedAlreadyLoaded, dimensionSystemName) {
        let rtnVal = []
        let dimensionCopied = copiedAlreadyLoaded.filter(x => x.dimensionSystemName === dimensionSystemName)

        for (let copiedItr = 0; copiedItr < dimensionCopied.length; copiedItr++) {
            let current = dimensionCopied[copiedItr]
            rtnVal.push(parseInt(current["systemName"]))
        }

        return rtnVal
    }
    function getCurrentItemMask(selectedDimensionSystemName, memberSystemName, membersWeAlreadyLoaded, changedItemMaskingList) {
        let memberFromItemMaskingList = changedItemMaskingList.filter(x => x.dimensionSystemName === selectedDimensionSystemName && x.memberSystemName === memberSystemName)
        if (memberFromItemMaskingList.length > 0) {
            return memberFromItemMaskingList[0]["maskingValue"]
        }

        let membersForDimension = membersWeAlreadyLoaded.filter(x => x.dimensionSystemName === selectedDimensionSystemName && x.systemName === memberSystemName)
        if (membersForDimension.length > 0) {
            return membersForDimension[0]["alias"]
        }

        return ''
    }
    function getIndexForMatchingItemOnList(changedMaskingList, memberSystemName, dimensionSystemName) {
        for (let memberItr = 0; memberItr < changedMaskingList.length; memberItr++) {
            let current = changedMaskingList[memberItr]
            
            if (current["dimensionSystemName"] === dimensionSystemName && current["memberSystemName"] === memberSystemName) {
                return memberItr
            }
        }

        return -1
    }
    //#endregion

    return (<Paper elevation={3} className="dbFunctionsPaper">
        <h3>Add Segments</h3>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-databse-label">Select Database</InputLabel>
            <Select
                labelId="select-databse-label"
                id="select-databse"
                label="Select Database"
                onChange={handleDatabase}
                defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                value={databaseId}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={-1}>Select Database</MenuItem>
                    { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
            <Select
                labelId="select-data-source-label"
                id="select-data-source"
                label="Select Data Source"
                onChange={handleDataSourceChange}
                value={dataSourceSystemName}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Data Source</MenuItem>
                    { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-dimension-label">Select Dimension</InputLabel>
            <Select
                labelId="select-dimension-label"
                id="select-dimension"
                label="Select Dimension"
                onChange={handleDimensionChange}
                value={selectedDimension}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Dimension</MenuItem>
                    { dimensions.map((x) => x && <MenuItem key={x.systemName} value={x.systemName}>{x.alias}</MenuItem>)}
            </Select>
        </FormControl>
        <Box sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: '250px', overflowY: 'scroll', marginTop: '15px' }}>
            {renderSegmentationAssignmentTable(selectedDimension, dimensions, loadedMembers, changedItemMaskingList, databaseId, dataSourceSystemName)}
        </Box>
        <Button variant="contained" fullWidth disabled={isLoadingRequest || dataSourceSystemName.trim().length === 0 || selectedDimension.trim().length === 0} onClick={(e) => {
            e.preventDefault()
            loadMoreDimensionMembers(databaseId, dataSourceSystemName, selectedDimension, loadedMembers)
        }}>Load More Members</Button>
    </Paper>)
}

export default ItemMaskingChange